/**
 * Configuration for organizations in this app.
 */
const jobiqoCompanyConfig = require('./../src/jobiqo/config/organizations');
const mergeDeepRight = require('ramda/src/mergeDeepRight');
const fixtures = require('./fixtures');

// We usually don't set flags here but we need to set this for behat tests to be
// able to update this flag when running.
const showOnlyFeaturedOrganizations = true;

module.exports = mergeDeepRight(jobiqoCompanyConfig, {
  // Insert config here. this will be deep merged with config from jobiqo. Arrays are not deep mergeable
  // so make sure to cover those with [...jobiqoCompanyConfig.public.SOME_KEY_THAT_IS_ARRAY, new_item ]
  public: {
    SHOW_ONLY_FEATURED_ORGANIZATIONS: showOnlyFeaturedOrganizations,
    GEO_INFO: {
      radius: {
        defaultValue: 25,
      },
      types: ['(regions)'],
      fixtures,
    },
  },
});
